import { render, staticRenderFns } from "./downturnDeatilDia.vue?vue&type=template&id=11501895&scoped=true"
import script from "./downturnDeatilDia.vue?vue&type=script&lang=js"
export * from "./downturnDeatilDia.vue?vue&type=script&lang=js"
import style0 from "./downturnDeatilDia.vue?vue&type=style&index=0&id=11501895&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11501895",
  null
  
)

export default component.exports